module.exports = __webpack_public_path__ + "img/parallax3-850p.a28ee66f.jpg";